/* src/app/components/dialogs/multi-doc-edit-dialog/multi-doc-edit-dialog.component.scss */
.multi-doc-edit-dialog-notice {
  margin: 10px;
  font-style: italic;
  color: gray;
}
:host-context(.dark-theme) .multi-doc-edit-dialog-notice {
  color: #cbcbcb;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
/*# sourceMappingURL=multi-doc-edit-dialog.component.css.map */
